export const type = 'form.button';
